import { applySpec, prop } from "ramda";

import { ProfileType } from "types/account";
import { ProcessData } from "types/process";
import { AdapterMapper } from "types/utils";
import { VirtualAssetsInd, VirtualAssetsOrg } from "types/virtualAssets";

class VirtualAssetsAdapterClass {
  commonMapper = {
    status: prop("status"),
    currentStep: prop("currentStep"),
    rejectionReasons: prop("rejectionReasons"),
    cryptoTrading: prop("cryptoTrading"),
    cryptoInvestmentLevel: prop("cryptoInvestmentLevel"),
    cryptoInvestmentFrequency: prop("cryptoInvestmentFrequency"),
    sharesTrading: prop("sharesTrading"),
    sharesInvestmentLevel: prop("sharesInvestmentLevel"),
    sharesInvestmentFrequency: prop("sharesInvestmentFrequency"),
    sourcesOfWealthDetails: prop("sourcesOfWealthDetails"),
    sourcesOfFundsDetails: prop("sourcesOfFundsDetails"),
  } as const;

  individualMapper = applySpec<VirtualAssetsInd>({
    ...this.commonMapper,
    sourcesOfWealth: prop("sourcesOfWealth"),
    sourcesOfFunds: prop("sourcesOfFunds"),
    netWorth: prop("netWorth"),
    annualIncome: prop("annualIncome"),
    taxId: prop("taxId"),
    phone: prop("phone"),
    phoneCountry: prop("phoneCountry"),
    phonePrefix: prop("phonePrefix"),
    employmentStatus: prop("employmentStatus"),
    occupation: prop("occupation"),
    businessName: prop("businessName"),
    businessSector: prop("businessSector"),
  });

  organizationalMapper = applySpec<VirtualAssetsOrg>({
    ...this.commonMapper,
    sourcesOfWealth: prop("sourcesOfWealth"),
    sourcesOfFunds: prop("sourcesOfFunds"),
    lastAccountsNetAsset: prop("lastAccountsNetAsset"),
    lastAccountsNetProfit: prop("lastAccountsNetProfit"),
  });

  takeOutData = (type: ProfileType, item: unknown) => {
    switch (type) {
      case "individual":
        return this.individualMapper(item);
      case "organizational":
        return this.organizationalMapper(item);
    }
  };

  toModel<T extends ProcessData<unknown>>(item: T, type: ProfileType) {
    return {
      last: this.takeOutData(type, item.last),
      current: this.takeOutData(type, item.current),
    };
  }
}

export const VirtualAssetsAdapter = new VirtualAssetsAdapterClass();
